<div class="content">
    <h1>{{"title.notFound" | translate}}</h1>

</div>